export const DESCARTE_COMMON_ATUALIZA_PERMISSAO_DESCARTE_MATERIAL = 'DESCARTE_COMMON_ATUALIZA_PERMISSAO_DESCARTE_MATERIAL';
export const permissaoDescarteMateriais = (permissaoDescarteMateriais) => ({
  type: DESCARTE_COMMON_ATUALIZA_PERMISSAO_DESCARTE_MATERIAL,
  payload: {
    permissaoDescarteMateriais,
  },
});

export const DESCARTE_COMMON_ATUALIZA_CONSULTA_DESCARTE_MATERIAL = 'DESCARTE_COMMON_ATUALIZA_CONSULTA_DESCARTE_MATERIAL';
export const permissaoConsultaDescarteMateriais = (permissaoConsultaDescarteMateriais) => ({
  type: DESCARTE_COMMON_ATUALIZA_CONSULTA_DESCARTE_MATERIAL,
  payload: {
    permissaoConsultaDescarteMateriais,
  },
});

export const DESCARTE_COMMON_ATUALIZA_TAB = 'DESCARTE_COMMON_ATUALIZA_TAB';
export const atualizarTab = (tab) => ({
  type: DESCARTE_COMMON_ATUALIZA_TAB,
  payload: {
    tab,
  },
});

export const DESCARTE_COMMON_TOTAL_MATERIAIS_A_VENCER = 'DESCARTE_COMMON_TOTAL_MATERIAIS_A_VENCER';
export const totalMateriaisavencer = (totalMateriaisavencer) => ({
  type: DESCARTE_COMMON_TOTAL_MATERIAIS_A_VENCER,
  payload: {
    totalMateriaisavencer,
  },
});
export const DESCARTE_COMMON_ATUALIZAR_DATAINI = 'DESCARTE_COMMON_ATUALIZAR_DATAINI';
export const dataInicio = (dataInicio) => ({
  type: DESCARTE_COMMON_ATUALIZAR_DATAINI,
  payload: {
    dataInicio,
  },
});
export const DESCARTE_COMMON_ATUALIZAR_DATAFIM = 'DESCARTE_COMMON_ATUALIZAR_DATAFIM';
export const dataFim = (dataFim) => ({
  type: DESCARTE_COMMON_ATUALIZAR_DATAFIM,
  payload: {
    dataFim,
  },
});

export const DESCARTE_COMMON_ATUALIZAR_FILTRO_VALUE = 'DESCARTE_COMMON_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: DESCARTE_COMMON_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});
export const DESCARTE_COMMON_ATUALIZA_MOTIVO = 'DESCARTE_COMMON_ATUALIZA_MOTIVO';
export const motivo = (motivo) => ({
  type: DESCARTE_COMMON_ATUALIZA_MOTIVO,
  payload: {
    motivo,
  },
});

export const DESCARTE_COMMON_ATUALIZA_PESO = 'DESCARTE_COMMON_ATUALIZA_PESO';
export const peso = (peso) => ({
  type: DESCARTE_COMMON_ATUALIZA_PESO,
  payload: {
    peso,
  },
});

export const DESCARTE_COMMON_ATUALIZA_OBSERVACAO = 'DESCARTE_COMMON_ATUALIZA_OBSERVACAO';
export const observacao = (observacao) => ({
  type: DESCARTE_COMMON_ATUALIZA_OBSERVACAO,
  payload: {
    observacao,
  },
});

export const DESCARTE_COMMON_ATUALIZA_IMPRIMIR = 'DESCARTE_COMMON_ATUALIZA_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: DESCARTE_COMMON_ATUALIZA_IMPRIMIR,
  payload: {
    imprimir,
  },
});


// WEBPACK FOOTER //
// ./src/pages/descarte/common/store/descarte.action.js